import { Icon } from './types';

export const OpenInNew = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="open-in-new"
    {...svgProps}
  >
    <path
      d="M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
